/** True while this recording still belongs to the actor, drawer, and conversation. */
export function voiceRecordingStillCurrent(input: {
  open: boolean;
  canWrite: boolean;
  actorKey: string;
  recordingActor: string;
  activeThreadId: string | null;
  recordingThread: string | null;
  createdThread: string | null;
}): boolean {
  if (!input.open || !input.canWrite || input.actorKey !== input.recordingActor) return false;
  if (input.recordingThread) return input.activeThreadId === input.recordingThread;
  // Started with no conversation. Keep going while selection is still empty or
  // lands on the thread created for this recording — including the window after
  // createThread returns but before React commits the new active ID.
  return input.activeThreadId == null || input.activeThreadId === input.createdThread;
}
